import { Box, Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

type AdminTab = { label: string; path: string; matchPrefix?: string };

const adminTabs: AdminTab[] = [
  { label: 'Profile', path: '/admin/profile' },
  { label: 'Organization', path: '/admin/settings' },
  { label: 'Users', path: '/admin/users' },
  { label: 'Note Templates', path: '/admin/note-templates' },
  { label: 'Documents', path: '/admin/documents', matchPrefix: '/admin/documents' },
];

type DocSubTab = { label: string; path: string; exact?: boolean };

const documentSubTabs: DocSubTab[] = [
  { label: 'Overview', path: '/admin/documents', exact: true },
  { label: 'Your signature', path: '/admin/documents/my-signature' },
  { label: 'Organization', path: '/admin/documents/settings' },
  { label: 'Templates', path: '/admin/documents/templates' },
  { label: 'Snippets', path: '/admin/documents/snippets' },
];

function documentSubTabIndex(pathname: string): number {
  const i = documentSubTabs.findIndex((t) =>
    t.exact ? pathname === t.path || pathname === `${t.path}/` : pathname.startsWith(t.path),
  );
  return i === -1 ? 0 : i;
}

export const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabMatches = (tab: AdminTab) =>
    location.pathname.startsWith(tab.matchPrefix ?? tab.path);

  const currentTab = adminTabs.findIndex(tabMatches);
  const tabValue = currentTab === -1 ? 0 : currentTab;

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(adminTabs[newValue].path);
  };

  const inDocuments = location.pathname.startsWith('/admin/documents');
  const docTabValue = documentSubTabIndex(location.pathname);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: inDocuments ? 1 : 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Admin navigation tabs">
          {adminTabs.map((tab) => (
            <Tab key={tab.path} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      {inDocuments ? (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={docTabValue}
            onChange={(_e, v) => navigate(documentSubTabs[v].path)}
            aria-label="Document admin sections"
            variant="scrollable"
            scrollButtons="auto"
          >
            {documentSubTabs.map((t) => (
              <Tab key={t.path} label={t.label} />
            ))}
          </Tabs>
        </Box>
      ) : null}
      <Outlet />
    </Box>
  );
};
